import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useCallback } from 'react';
import Table from '../Table';
import HowToMeasure from '../HowToMeasure';
import ListSection from '../ListSection';
import { getData } from '../../categoryData';
import * as Common from '../Common.styles';
var CONTENT = getData('Womens Trousers & Jeans');

var WomensTrousersAndJeans = function WomensTrousersAndJeans(_ref) {
  var dataTest = _ref.dataTest;

  var _useState = useState('cm'),
      _useState2 = _slicedToArray(_useState, 2),
      unit = _useState2[0],
      setUnit = _useState2[1];

  var onUnitToggle = useCallback(function (e) {
    return setUnit(e.target.checked ? 'inch' : 'cm');
  });
  var tables = CONTENT.tables,
      howToMeasure = CONTENT.howToMeasure,
      tall = CONTENT.tall,
      maternity = CONTENT.maternity;
  return /*#__PURE__*/React.createElement(Common.Container, null, /*#__PURE__*/React.createElement(Common.MeasurementsContainer, null, /*#__PURE__*/React.createElement(Common.Heading, null, "Measurements"), /*#__PURE__*/React.createElement(Common.SubHeading, null, "Check your measurements to find your size."), tables.map(function (tableProps, index) {
    return /*#__PURE__*/React.createElement(Table, _extends({
      key: index,
      unit: unit,
      onUnitToggle: onUnitToggle
    }, tableProps));
  })), /*#__PURE__*/React.createElement(Common.HowToMeasureContainer, null, /*#__PURE__*/React.createElement(HowToMeasure, {
    unit: unit,
    image: howToMeasure.image,
    content: howToMeasure.content,
    dataTest: dataTest
  }), /*#__PURE__*/React.createElement(ListSection, {
    unit: unit,
    title: tall.title,
    content: tall.content
  }), /*#__PURE__*/React.createElement(ListSection, {
    title: maternity.title,
    content: maternity.content
  })));
};

export default WomensTrousersAndJeans;